// extracted by mini-css-extract-plugin
module.exports = {"boxButtonPaginator":"ShowMoreButton_boxButtonPaginator__3p27J","buttonPaginator":"ShowMoreButton_buttonPaginator__1GHX1"};